<template>
  <div :class="['card-footer', props.class]">
    <slot />
  </div>
</template>

<script setup>
/* eslint-disable vue/require-default-prop */
const props = defineProps({
  class: { type: null, required: false },
})
</script>
